import { type SelectionsMachine } from '../../../machine/selection-machine';
import { type SharedEventLoop } from '../../event-loop';
import { type SelectionInput } from '../../types';
import { createKeyboardInputFor } from '../create-keyboard-input-for';

import { handleTableCellActionsKeyDown } from './handle-table-cell-actions-key-down';

/**
 * Creates the table keyboard input for legacy focused-cell actions.
 *
 * This input intentionally owns only edit/clear/deselect actions. Table
 * movement, range extension, and traversal should live in dedicated keyboard
 * inputs so those behaviors can be gated and tested independently.
 */
export function createTableCellActionsInput(
  machine: SelectionsMachine,
  sharedLoop: SharedEventLoop
): SelectionInput {
  return createKeyboardInputFor(machine, sharedLoop, {
    handler: handleTableCellActionsKeyDown,
  });
}
